import { ISettlementAndFeeCategoryDefinitionData } from 'types/order/fees/ISettlementAndFeeCategoryDefinition';
import { availablePropertiesBySelection } from './useAvailablePropertiesBySelection';

export interface IAdjustFeeToKeepSharedValuesProps {
  numericFeePropertyValues: { [key: string]: any };
  oldDefinitionId?: string;
  newDefinitionId?: string;
  options: ISettlementAndFeeCategoryDefinitionData[];
}

export const adjustFeeToKeepSharedValues = ({
  numericFeePropertyValues,
  options,
  oldDefinitionId,
  newDefinitionId,
}: IAdjustFeeToKeepSharedValuesProps): { [key: string]: any } => {
  const newFee = { ...numericFeePropertyValues };
  const oldCategoryProperties = availablePropertiesBySelection(options, oldDefinitionId);
  const newCategoryProperties = availablePropertiesBySelection(options, newDefinitionId);
  for (const propertyValue in newFee) {
    if (!oldCategoryProperties[propertyValue] || !newCategoryProperties[propertyValue]) {
      newFee[propertyValue] = undefined;
    }
  }
  return newFee;
};
